/* eslint-disable prefer-template */
import * as Sentry from '@sentry/react';

function jsonToCsv(jsonData: Record<string, any>[]): string {
  const headers = Object.keys(jsonData[0]);
  return [
    // Headers
    headers.join(','),
    // Body
    jsonData
      .map((row) =>
        headers
          .map((header) => {
            const value = row[header] ?? '';
            return typeof value === 'string' && /[",\n]/.test(value)
              ? `"${value.replace(/"/g, '""')}"`
              : value;
          })
          .join(',')
      )
      .join('\n'),
  ].join('\n');
}

export const downloadFileFromJson = (data: Record<string, unknown>[], fileName?: string) => {
  try {
    const csvData = jsonToCsv(data);

    const blob = new Blob([csvData], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = fileName ?? 'export.csv';
    a.click();
    window.URL.revokeObjectURL(url);
  } catch (error: any) {
    Sentry.captureException(error, {
      level: 'warning',
      extra: { fileName },
    });
    alert('Failed to download the file!');
  }
};
